export const sizeClasses = ['large', 'small', 'xsmall'];
export const fontWeight = 700;
export const textColor = '#FFF';
export const backgroundColor = '#A9132A';

export const paddings = {
  large: '0.4rem 0.8rem',
  small: '0.4rem',
  xsmall: '0.2rem 0.4rem',
};

export const fontSizes = {
  large: '1.8rem',
  small: '1.4rem',
  xsmall: '1.4rem',
};
